import fs from 'fs';
import axios from 'axios';

const downloadImage = (url, imagePath) => {
    return axios({
        url,
        responseType: 'stream',
    }).then(
        response =>
            new Promise((resolve, reject) => {
                response.data
                    .pipe(fs.createWriteStream(imagePath))
                    .on('finish', () => resolve())
                    .on('error', e => reject(e));
            }),
    );
}

export default downloadImage;